import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import {
  fetchProductsInitAction, getProductSuccessAction,
  updateProductFiltersAction,
  updateSelectedProductAction,
} from '../../../../../actions/instances/products';
import FullPageLoader from '../../../../atoms/FullPageLoader/FullPageLoader';
import EmptyView from '../../../../molecules/EmptyView/EmptyView';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import TagsSelector from '../../../../atoms/TagsSelector/TagsSelector';
import ProductTypeSelector from '../../../../atoms/ProductTypeSelector/ProductTypeSelector';
import Sidebar from '../../../../molecules/Sidebar/Sidebar';
import Icon from '../../../../atoms/Icon/Icon';
import ListBase from '../../../../Organisms/ListBase/ListBase';
import ListItem from '../../../../molecules/ListItem/ListItem';
import './ListProducts.scss';

const ListProducts = () => {
  const {
    isLoadingProducts,
    didLoadProducts,
    products,
    filters,
  } = useSelector(state => state.products);
  const isFiltersDirty = filters.dynasties.length > 0
    || filters.cities.length > 0
    || filters.tags.length > 0;
  const dispatch = useDispatch();
  const history = useHistory();
  if (!didLoadProducts && !isLoadingProducts) {
    dispatch(fetchProductsInitAction());
  }
  if (isLoadingProducts) {
    return <FullPageLoader />;
  }
  return (
    <>
      {
        products.length === 0 && !isFiltersDirty
          ? (
            <EmptyView
              message="Looks like there's no building products here yet."
              action={() => {
                history.push('/instances/building-products/create');
              }}
            />
          ) : (
            <div className="components-page-content">
              <div className="row actions-container">
                <h4 className="mb-4">Products Filters</h4>
                <div className="filters">
                  <div className="actions">
                    <div className="filter-item">
                      <DynastySelector
                        isMulti
                        onChanged={(val) => {
                          filters.dynasties = val.map(dynasty => dynasty.value);
                          dispatch(updateProductFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <CitySelector
                        isMulti
                        onChanged={(val) => {
                          filters.cities = val.map(city => city.value);
                          dispatch(updateProductFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <TagsSelector
                        isMulti
                        onChanged={(val) => {
                          filters.tags = val.map(tag => tag.value);
                          dispatch(updateProductFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <ProductTypeSelector
                        isMulti
                        onChanged={(val) => {
                          filters.types = val.map(tag => tag.value);
                          dispatch(updateProductFiltersAction(filters));
                        }}
                      />
                    </div>
                  </div>
                  <Button
                    variant="default"
                    onClick={() => {
                      dispatch(getProductSuccessAction(undefined));
                      history.push('/instances/building-products/create');
                    }}
                  >
                    <Icon icon="plus" color="#000" />
                  </Button>
                </div>
              </div>
              <div className="row components-list">
                <div className="col-md-9">
                  {products && products.length > 0 ? (
                    <ListBase>
                      {products.map(product => (
                        <ListItem
                          imgSrc={product.images.length > 0 ? product.images[0].url : '/images/default.jpg'}
                          name={product.name}
                          code={product.code}
                          dynasty={product.dynasty.name}
                          location={`${product.city.name} [${product.city.country.code}-${product.city.code}]`}
                          creationDate={product.created_at}
                          onViewClicked={() => {
                            dispatch(updateSelectedProductAction(product));
                            history.push('/instances/building-products/view');
                          }}
                          onEditClicked={() => {
                            dispatch(getProductSuccessAction(product));
                            history.push('/instances/building-products/create');
                          }}
                          inReview={product.in_review}
                        />
                      ))}
                    </ListBase>
                  ) : (
                    <EmptyView
                      message="No products matches these filters"
                      action={() => history.push('/instances/building-products/create')}
                    />
                  )}
                </div>
                <div className="col-md-3 p-0">
                  <Sidebar />
                </div>
              </div>
            </div>
          )
      }
    </>
  );
};

export default ListProducts;
